import { ImagePickerResponse } from "react-native-image-picker"
import { LocalImage } from "../types"

const imagePickerResponseToLocalImage = (res?: ImagePickerResponse): LocalImage | undefined => {
  const image = res?.assets?.[0]

  if (!image || !image.uri) return

  return {
    path: image.uri,
    filename: image.fileName as string,
    mime: image.type as string,
  }
}

export default imagePickerResponseToLocalImage
